import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import { useState, useEffect } from 'react';
import raf from 'raf';
import ResizeObserver from 'resize-observer-polyfill';

function useResizeObserver(handler, el) {
  var _useState = useState(el),
      _useState2 = _slicedToArray(_useState, 2),
      node = _useState2[0],
      setRef = _useState2[1];

  var resizeObserver = new ResizeObserver(function (entries) {
    if (!Array.isArray(entries)) return;
    if (!entries.length) return;
    var entry = entries[0]; // execute on the next animation frame

    raf(function () {
      return handler({
        width: entry.target.offsetWidth,
        height: entry.target.offsetHeight
      }, entry.target);
    });
  });
  var htmlEl = el || node;
  useEffect(function () {
    if (htmlEl) resizeObserver.observe(htmlEl);
    return function () {
      return htmlEl && resizeObserver.unobserve(htmlEl);
    };
  }, [htmlEl]);
  return [setRef];
}

export default useResizeObserver;
//# sourceMappingURL=useResizeObserver.js.map
